export default __webpack_public_path__ + "static/media/ClientReviewsGreen.3f5e2ed0.svg";